import React, { useState} from 'react';
import styled from 'styled-components';
import IATrainingEdit from './iaTrainingEdit';
import IATrainingAdd from './iaTrainingAdd';
import ChevronDownIcon from '../Assets/icons/chevron.svg';
import {  ChevronWrapper,  EditLabel } from './StyledComponents';
import useIAProfileData from '../Hooks/IAtrainingHooks/useIaTraining';
import adminBg from '../Assets/bg/adminbg.jpg';
import Loader from '../Components/Loader';

const IaTraining = ({ setShowIATraining, isSidebarExpanded, darkMode }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { data, loading, error } = useIAProfileData();


  const handleEditData = (item) => {
    setSelectedItem(item);
    setShowEditPanel(true);
  };

  const closeEditPanel = () => {
    setShowEditPanel(false);
    setSelectedItem(null);
  };

  const filteredData = data.filter(item =>
    (item.region?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.municipality?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.projectName?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );
  
 if (loading) {
     return (
       <div style={{
         display: 'flex',
         justifyContent: 'center',
         alignItems: 'center',
         height: '100vh',
         backgroundColor: darkMode ? 'black' : 'white',
       }}>
         <Loader />
       </div>
     );
   }   

  if (error) {
    return <div>Error: {error.message}</div>; 
  }

  return (
    <SlidingPanel darkMode={darkMode} show={true} isSidebarExpanded={isSidebarExpanded}>
    <Container darkMode={darkMode} isSidebarExpanded={isSidebarExpanded}>
    <Header darkMode={darkMode}>
    <Heading darkMode={darkMode}>IA Training</Heading>
        </Header>

        <SearchContainer>
        <SearchInput
          type="text"
          placeholder="Search Province..."
          value={searchQuery}
           onChange={(e) => setSearchQuery(e.target.value)}
        />
        </SearchContainer>

        <TableWrapper>
        <Table darkMode={darkMode}>
            <thead>
              <tr>
                <TableHeader  darkMode={darkMode}>No</TableHeader>
                <TableHeader  darkMode={darkMode}>REGION</TableHeader>
                <TableHeader  darkMode={darkMode}>IMO</TableHeader>
                <TableHeader  darkMode={darkMode}>PROVINCE</TableHeader>
                <TableHeader  darkMode={darkMode}>MUNICIPALITY</TableHeader>     
                <TableHeader  darkMode={darkMode}>NAME OF PROJECT/SYSTEM</TableHeader>
                <TableHeader  darkMode={darkMode}>NAME OF IRRIGATORS' ASSOCIATION</TableHeader>

                <TableHeader darkMode={darkMode} colSpan="2" style={{ textAlign: 'center' }}>
                  TRAININGS CONDUCTED 
                </TableHeader>

                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center' }}>
                NO. OF BATCHES
                </TableHeader>
              
                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center' }}>
                DATE CONDUCTED </TableHeader>

                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center' }}>
                NO. OF PARTICIPANTS </TableHeader>
            
                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center' }}>
                VENUE </TableHeader>
            
              </tr>

              <tr>
              <TableHeaderS  colSpan="1" darkMode={darkMode}></TableHeaderS>
              <TableHeaderS  colSpan="6" darkMode={darkMode}></TableHeaderS>
              <TableHeaderS darkMode={darkMode}>REGULAR</TableHeaderS>
              <TableHeaderS darkMode={darkMode}>OTHER</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>REGULAR</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>OTHER</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>REGULAR</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>OTHER</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>REGULAR</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>OTHER</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>REGULAR</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>OTHER</TableHeaderS>

           </tr>
            </thead>
            <tbody>
            {filteredData.map((item, index) => (
                <TableRow key={item.id} darkMode={darkMode}>
                  <TableData darkMode={darkMode}>
                  {index + 1}
                    <ChevronWrapper>
             <StyledChevronIcon src={ChevronDownIcon} alt="Chevron" />
             <EditLabel onClick={() => handleEditData(item)}> Edit</EditLabel>
            </ChevronWrapper>
                  </TableData>
                  <TableData darkMode={darkMode}>{item.region}</TableData>
                  <TableData darkMode={darkMode}className="station-imo">{item.imo}</TableData>
                  <TableData darkMode={darkMode}>{item.province}</TableData>
                  <TableData darkMode={darkMode}>{item.municipality}</TableData>
                  <TableData darkMode={darkMode}>{item.projectName}</TableData>
                  <TableData darkMode={darkMode}className="station-iaName">{item.ia_name}</TableData>
                  <TableData darkMode={darkMode}className="station-trainedReg">{item.trainingsConducted_regular}</TableData>
                  <TableData darkMode={darkMode}>{item.trainingsConducted_other}</TableData>
                  <TableData darkMode={darkMode}>{item.batchesNum_regular}</TableData>
                  <TableData darkMode={darkMode}>{item.batchesNum_other}</TableData>
                  <TableData darkMode={darkMode}>{item.dateConducted_regular}</TableData>
                  <TableData darkMode={darkMode}>{item.dateConducted_other}</TableData>  
                  <TableData darkMode={darkMode}>{item.participantsNum_regular}</TableData>
                  <TableData darkMode={darkMode}>{item.participantsNum_other}</TableData>
                  <TableData darkMode={darkMode}>{item.venue_regular}</TableData>
                  <TableData darkMode={darkMode}>{item.venue_other}</TableData>
                  
                </TableRow>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

        {showEditPanel && <IATrainingEdit selectedItem={selectedItem} closeEditPanel={closeEditPanel} />}
      </Container>

      <RightPanel  darkMode={darkMode} >
      <IATrainingAdd darkMode={darkMode}/>
      </RightPanel>
    </SlidingPanel>
  );
};

export default IaTraining;

const Container = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: ${({ darkMode }) => (darkMode ? ' #757272' : '#333')};
  display: 'flex',
  padding: 10px;
  width: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'calc(100% - 110px)' : '55%')};
  min-height: 100vh;
  overflow-y: auto;
  margin-left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '110px' : '10px')};
  
  margin-top: 30px;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transition: margin-left 0.3s ease, width 0.3s ease;
`;

const SlidingPanel = styled.div`
  position: fixed;
  top: 0px;
  right: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '0%' : '0')};
  width: 97%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#ccc')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease, right 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0px;
  margin-bottom: 5px;
  margin-top: 5px;
`;

const Heading = styled.h2`
  font-size: 20px;
 color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  font-weight: bold;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 0px;
`;


const StyledChevronIcon = styled.img`
  margin-top: -25px;  
  margin-left: 5px;  
   width: 14px; 
  height: 14px; 
`;


const TableWrapper = styled.div`
  width: 100%;
  height: 75vh;
 overflow: auto; 
 margin-top: 10px;
position: relative;
background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f2f2f2')};

`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 1500px;
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
`;;

const TableHeaderS = styled.th`
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(7, 128, 53)' : '#f2f2f2')};
 padding: 0 10px;
  top: 39px;
  position: sticky;
  z-index: 1;
  text-align: center;
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; 
  border-bottom: 2px solid #ddd;
  font-size: 12px;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(7, 128, 53)' : '#f2f2f2')}; /* Ensure it matches the background */
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableHeader = styled.th`
  position: sticky;
  background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')};
  padding: 0 20px;
  height: 10px;
  top: 0px;

  z-index: 2;
  text-align: center;  /* Center text horizontally */
  vertical-align: middle; 
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; /* Keep top border */
  border-bottom: none;
  font-size: 14px;
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  margin-top: 10px;

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')}; 
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableData = styled.td`
  padding: 5 5px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ddd;
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
 
  transition: background-color 0.3s ease, color 0.3s ease;

  &:first-child {
    position: sticky;
    left: 0;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)2' : '#f2f2f2')}; 
    
   };
    z-index: 1;
  }
 
  &.station-imo {
    min-width: 150px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-iaName {
    min-width: 250px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-trainedReg {
    min-width: 220px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TableRow = styled.tr`
 background: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#fff')};
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};

   &:hover {
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : 'rgb(37, 112, 46)')};
    background-size: cover;
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#fff')}; 
    z-index: 10;
  }

 
  &:hover td {
    background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
    background-size: cover;
    color: ${({ darkMode }) => (darkMode ? '#fff' : '#fff')};  
  }
`;

const RightPanel = styled.div`
  position: fixed;
  padding-top: 10px;
  top: 0;
  right: 0;
  width: 43%;
 height: 1%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  z-index: ${({ showEditPanel }) => (showEditPanel ? 1 : 0)};
  padding: 10px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-top: 0px;
`;

const SearchInput = styled.input`
  padding: 8px;
  font-size: 14px;
  width: 250px;
  border: 1px solid #f2f2f2;
  border-radius: 5px;
`;